module.exports = __webpack_public_path__ + "img/score.0f843925.png";